import signIn from './module';

export default signIn();
